export const MarkingPayOptions = [
    { value: 'none', label: 'Не задано' },
    { value: 'pre_payment', label: 'Предоплата' },
    // { value: 'post_payment', label: 'По факту' },
] as const

export type MarkingPayType = (typeof MarkingPayOptions)[number]['value']
interface MarkingPayOptionType {
    value: MarkingPayType
    label: string
}
export const typedMarkingPayOptions: readonly MarkingPayOptionType[] =
    MarkingPayOptions

export const MarkingPublishingDurationOptions = [
    { value: 'no_duration', label: 'Не задано' },
    { value: 'no_end_date', label: 'Без даты удаления' },
    { value: '1/24', label: '1/24' },
    { value: '1/36', label: '1/36' },
    { value: '1/48', label: '1/48' },
    { value: '2/48', label: '2/48' },
    { value: '3/48', label: '3/48' },
    { value: '3/72', label: '3/72' },
    { value: '1/120', label: '1/120' },
    { value: '6/120', label: '6/120' },
    { value: '3/168', label: '3/168' },
    { value: '4/168', label: '4/168' },
    { value: '6/720', label: '6/720' },
    // { value: '3/∞', label: '3/∞' },
] as const

export type MarkingPublishingDurationType =
    (typeof MarkingPublishingDurationOptions)[number]['value']
export interface MarkingPublishingDurationOptionType {
    value: MarkingPublishingDurationType
    label: string
}
export const typedMarkingPublishingDurationOptions: readonly MarkingPublishingDurationOptionType[] =
    MarkingPublishingDurationOptions

export const MarkingVatOptions = [
    { value: '-1', label: 'Без НДС' },
    { value: '0', label: '0%' },
    { value: '5', label: '5%' },
    { value: '7', label: '7%' },
    { value: '10', label: '10%' },
    // { value: '15', label: '15%' },
    // { value: '20', label: '20%' },
    { value: '22', label: '22%' },
] as const

export type MarkingVatType = (typeof MarkingVatOptions)[number]['value']
interface MarkingVatOptionType {
    value: MarkingVatType
    label: string
}
export const typedMarkingVatOptions: readonly MarkingVatOptionType[] =
    MarkingVatOptions
